import React, { Component } from "react";
import {
  Wrapper,
  Card,
  CardBody,
  Title,
  Copy
} from "app/NativeComponents/common";
import { TextButton } from "app/NativeComponents/snippets";

import Register from "app/DealMachineCore/components/Register";

class FormContainer extends Component {
  render() {
    return (
      <div className="deal-start-right">
        <Wrapper
          style={{
            minHeight: 800
          }}
        >
          <CardBody>
            <Title
              style={{
                marginBottom: 5
              }}
            >
              {this.props.signup_type == "team_invite" ||
              this.props.signup_type == "team_open_invite"
                ? "Join " + this.props.signup_team_name + "'s Team"
                : "Try DealMachine FREE for 14 days"}
            </Title>
            <Copy>
              Join 5,000 investors who trust DealMachine to scale their real
              estate business.
            </Copy>
          </CardBody>
          <Register no_container />
          <TextButton
            to="/login"
            onPress={() => this.props.appRedirect({ redirect: "login" })}
            text="Already have an account? Log in."
          />
        </Wrapper>
      </div>
    );
  }
}

export default FormContainer;
